import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface QueryState {
  queryString: string;
}

const initialState: QueryState = {
  queryString: "",
};

const querySlice = createSlice({
  name: "query",
  initialState,
  reducers: {
    setQueryString(state, action: PayloadAction<string>) {
      state.queryString = action.payload;
    },
    clearQueryString(state) {
      state.queryString = "";
    },
  },
});

export const { setQueryString, clearQueryString } = querySlice.actions;
export default querySlice.reducer;
